import { motion } from "framer-motion";
import { Home, Users, Laptop, GraduationCap } from "lucide-react";
import { staggerParent, staggerChild } from "./Reveal";
import { Reveal } from "./Reveal";
import { IMG } from "../../lib/assets";

const BLOCKS = [
  {
    icon: Home,
    title: "Local Resident",
    body: "A long-time member of the Pembina Trails community.",
  },
  {
    icon: Users,
    title: "Parent",
    body: "Committed to creating the best possible future for our children.",
  },
  {
    icon: Laptop,
    title: "Technology Professional",
    body: "Bringing modern perspectives and innovative thinking.",
  },
  {
    icon: GraduationCap,
    title: "Post-Secondary Education Professional",
    body: "Understanding the pathways that help students succeed beyond high school.",
  },
];

export const WhyNoman = () => {
  return (
    <section className="py-20 lg:py-28 bg-slate-50 border-y border-slate-100" data-testid="why-noman-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-600">Why Noman</p>
          <h2 className="font-display font-extrabold tracking-tight text-slate-900 text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl leading-tight">
            Experience that reflects our community
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-12 gap-6">
          <motion.div
            variants={staggerParent}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className="lg:col-span-7 grid sm:grid-cols-2 gap-6"
          >
            {BLOCKS.map((b) => (
              <motion.div
                key={b.title}
                variants={staggerChild}
                className="group rounded-2xl bg-white border border-slate-200 p-7 hover:-translate-y-1 hover:shadow-lg transition-transform duration-300"
                data-testid={`whynoman-block-${b.title.toLowerCase().replace(/[^a-z]/g, "")}`}
              >
                <div className="inline-flex items-center justify-center rounded-full bg-teal-50 text-teal-700 h-14 w-14 group-hover:bg-teal-600 group-hover:text-white transition-colors">
                  <b.icon size={26} strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-xl font-bold tracking-tight text-slate-900 mt-5 leading-snug">
                  {b.title}
                </h3>
                <p className="mt-2 text-slate-600 leading-relaxed">{b.body}</p>
              </motion.div>
            ))}
          </motion.div>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden border border-slate-200 h-full min-h-[320px]">
              <img src={IMG.family} alt="Happy diverse community family" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
              <div className="absolute bottom-0 p-7">
                <p className="font-display text-2xl font-bold text-white leading-tight">
                  Community first, always.
                </p>
                <p className="mt-2 text-teal-100">
                  Strong schools built through collaboration and meaningful engagement with families.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
